import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IBanner } from "../bannerModel";

export const getAllBanner = createAsyncThunk(
  "Banner/FindAllBanner",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Banner/FindAllBanner`,
        {
          BannerTitle: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Banner:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createBanner = createAsyncThunk(
  "Banner/InsertBanner",
  async (BannerData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Banner/InsertBanner`,
        BannerData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Banner:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateBanner = createAsyncThunk(
  "Banner/UpdateBanner",
  async (BannerData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Banner/UpdateBanner`,
        BannerData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Banner:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteBanner = createAsyncThunk(
  "Banner/DeleteBanner",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Banner/DeleteBanner`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Banner :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getBannerByID = createAsyncThunk(
  "Banner/FindByIDBanner",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Banner/FindByIDBanner`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,

        BannerType: result.BannerType,
        BannerTitle: result.BannerTitle,
        SubTitle: result.SubTitle,
        Description: result.Description,
        BannerImage: result.BannerImage,
        IconKey: result.IconKey,
        AltTitle: result.AltTitle,
        ContentTitle: result.ContentTitle,
        IsActive: result.IsActive ? 1 : 2,
      } as IBanner;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Banner :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveBanner = createAsyncThunk(
  "Banner/FindAllActiveBanner",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Banner/FindAllActiveBanner`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Banner:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveBanner = createAsyncThunk(
  "Banner/ActiveInActiveBanner",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Banner/ActiveInActiveBanner`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Banner :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const BannerDetailsImageUpload = createAsyncThunk(
  "Banner/BannerImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Banner/BannerImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Banner Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
